
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class TradeMacroGrid extends SiteEntityGrid<TradeMacroRow, any> {
        protected getColumnsKey() { return 'Rebalancer.TradeMacro'; }
        protected getDialogType() { return TradeMacroDialog; }
        protected getIdProperty() { return TradeMacroRow.idProperty; }
        protected getLocalTextPrefix() { return TradeMacroRow.localTextPrefix; }
        protected getService() { return TradeMacroService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

    }
}